// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KaHW","col":"styles_col__1MGvO"};